export const userLogoutConfirmDialogStrings = {
    title: 'Abmelden',
    message: 'Sie haben bereits Daten hochgeladen. Wenn Sie sich abmelden, wird die Tabelle geschlossen und Ihre Änderungen gehen verloren. Wollen Sie das?',
    confirmButtonLabel: 'Ok',
    cancelButtonLabel: 'Abbrechen'
};
